

const Helpers = {

    install(Vue, options) {

        Vue.prototype.displayImage = function (image, width, height) {

            if(!image) return "";

            return window.cms + image.display +
                (width !== null && typeof width !== "undefined" && !isNaN(width) ? "?w=" + width : "") +
                (height !== null && typeof height !== "undefined" && !isNaN(height) ?
                    (width !== null && typeof width !== "undefined" && !isNaN(width) ? "&" : "?") + "h=" + height : "");
        };

        Vue.prototype.encodeUrl = function(str) {

            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
            let to   = "aaaaeeeeiiiioooouuuunc------";
            for (let i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        };

        Vue.prototype.sloDate = function(date) {

            // 15th february 2018
            return (typeof moment !== "undefined" ? moment(date).format("Do MMMM YYYY") : date);
        };

        Vue.prototype.getParameterByName = function(name, url) {

            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };
    }
};

export default Helpers;



// WEBPACK FOOTER //
// ./src/helpers.js